import axios from 'axios'

export const booking_package_service = {

  async get_package_booking(enviroment) {
    return axios.get(`booking-directory/33333333/ACTIVE`)
  },
}